<script lang="ts">
    import { Link } from "svelte-navigator";
    import User from "../../../GlobalComponents/User.svelte";
    import routesGroups from "../../../settings/settings";
    import { mediaQuery } from "../../../store/stores";
    import MenuItemIterator from "./MenuItemIterator.svelte";

    let openBurger = false;

    const toggleBurger = () => {
        openBurger = !openBurger;
    };

    console.log(routesGroups);
</script>

{#if $mediaQuery.mql.matches}
    <nav class="navbar is-fixed-top" aria-label="main navigation">
        <div class="navbar-brand ">
            <div class="brand padding-left"><Link to="/">Whizad</Link></div>
            <!-- svelte-ignore a11y-missing-attribute -->
            <a
                role="button"
                class="navbar-burger {openBurger ? 'is-active' : null}"
                data-target="navMenu"
                aria-label="menu"
                aria-expanded="false"
                on:click={() => toggleBurger()}
            >
                <span aria-hidden="true" />
                <span aria-hidden="true" />
                <span aria-hidden="true" />
            </a>
        </div>
        <!-- <div class="modal {openBurger ? 'is-active' : null}">
            <div class="modal-background" />
        </div> -->
        <div class="navbar-menu {openBurger ? 'is-active' : null}">
            <div class="navbar-start padding-left">
                {#each routesGroups as routesGroup}
                    <MenuItemIterator
                        {routesGroup}
                        onClickCallback={toggleBurger}
                    />
                {/each}
            </div>

            <div class="navbar-end">
                <div class="navbar-item">
                    <User onClickCallback={toggleBurger} />
                </div>
            </div>
        </div>
    </nav>
{:else}
    <div class="block">
        <div class="stick-nav">
            <div class="brand is-hidden-mobile"><Link to="/">Whizad</Link></div>
            <aside class="menu is-hidden-mobile">
                {#each routesGroups as routesGroup}
                    <MenuItemIterator
                        {routesGroup}
                        onClickCallback={() => {}}
                    />
                {/each}
            </aside>
        </div>
    </div>
{/if}

<style>
    .brand {
        text-align: left;
        font-size: 2rem;
        flex-direction: row;
        color: #9441f2;
        text-transform: uppercase;
        font-weight: 100;
        justify-content: space-between;
        margin-bottom: 1rem;
        padding-left: 20px;
    }

    .menu {
        text-align: left;
    }

    .left-bar {
    }

    .padding-left {
        padding-left: 1.2rem;
    }

    .max-width {
        max-width: 15rem;
    }

    .column {
        background-color: white;
        border-radius: 10px;
    }

    .stick-nav {
        box-shadow: 0 0.5em 1em -0.125em rgb(10 10 10 / 10%),
            0 0px 0 1px rgb(10 10 10 / 2%);
        position: sticky;
        top: 2rem;
        width: 25rem;
        background-color: white;
        padding: 30px;
        border-radius: 20px;
    }
    .block {
        display: block;
    }
</style>
